import { createFileRoute } from "@tanstack/react-router";

import { ThreadPage } from "@/features/support/pages";

export const Route = createFileRoute("/_app/specialists/support/$threadId")({
  component: Thread,
});

function Thread() {
  const { threadId } = Route.useParams();
  return <ThreadPage key={threadId} threadId={threadId} />;
}
